import React from 'react';

export default function DropdownArrow() {
  return (
    <svg width={10} height={5} viewBox="0 0 15 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g transform="translate(-4090 -21776)">
        <g>
          <use xlinkHref="#dropdownarrow-path0_fill" transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 4106 21787)" fill="#646464" />
        </g>
      </g>
      <defs>
        <path id="dropdownarrow-path0_fill" d="M 8.5 0L 15.8612 10.5L 1.13878 10.5L 8.5 0Z" />
      </defs>
    </svg>
  );
}
